import { load } from "../../events/load";

const initServicesContentReadMore = () => {
    const readMoreButton = document.querySelector(".services-content__read-more");
    const textContent = document.querySelector(".services-content__text");

    if (!readMoreButton || !textContent) return;

    // Перевіряємо чи потрібна кнопка (чи контент перевищує 10 рядків)
    const checkOverflow = () => {
        const isMobile = window.matchMedia('(max-width: 992px)').matches;

        if (isMobile) {
            const lineHeight = parseFloat(getComputedStyle(textContent).lineHeight) || 22;
            const maxHeight = lineHeight * 10;

            if (textContent.scrollHeight > maxHeight + 10) {
                readMoreButton.style.display = 'flex';
            } else {
                readMoreButton.style.display = 'none';
            }
        } else {
            readMoreButton.style.display = 'none';
            textContent.classList.remove('is-expanded');
            readMoreButton.classList.remove('is-expanded');
        }
    };

    readMoreButton.addEventListener("click", () => {
        textContent.classList.toggle("is-expanded");
        readMoreButton.classList.toggle("is-expanded");

        const textElement = readMoreButton.querySelector(".btn__text");
        if (textElement) {
            textElement.textContent = textContent.classList.contains("is-expanded")
                ? "Згорнути"
                : "Читати більше";
        }
    });

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
};

load(initServicesContentReadMore);

